'use client'

export function getNetworkInfo(): Record<string, string | number | boolean> | null {
  let connection: any

  try {
    if (!('connection' in navigator)) {
      return null
    }

    connection =
      (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection

    if (!connection) {
      return null
    }
  } catch (e) {
    return null
  }

  const networkInfo: Record<string, string | number | boolean> = {}

  // Connection type
  if (connection.effectiveType) {
    networkInfo['nw-connection-type'] = connection.effectiveType
  }

  // Effective bandwidth in Mbps
  if (connection.downlink) {
    networkInfo['nw-effective-bandwidth'] = connection.downlink
  }

  // Round trip time in milliseconds
  if (connection.rtt) {
    networkInfo['nw-round-trip-time'] = connection.rtt
  }

  // Data saver mode
  if ('saveData' in connection) {
    networkInfo['nw-data-saver'] = connection.saveData
  }

  return networkInfo
}
